// extracted by mini-css-extract-plugin
export default {"shift-fulfilment-modal-job-description__role_changes":"nM_IAIinH0wh4yUvM7iz","shift-fulfilment-modal-job-description__button":"f4DujCgaQufEcQgKL8Jv"};